// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QUGEOGm8RCVGK0CCYQKv {
  display: flex;
  padding: 0.4375rem 0;
}

.d8UbBaTPdBHCLRWWIW8Z {
  display: flex;
  flex-direction: column;
}

.QG6LffBNcAkvTLMDoLfK {
  margin-top: 0.25rem;
  font-weight: 400;
  font-size: 1rem;
  color: var(--grey-400);
}
`, "",{"version":3,"sources":["webpack://./src/components/Usp/Usp.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB","sourcesContent":[".usp {\n  display: flex;\n  padding: 7px 0;\n}\n\n.textContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.subTitle {\n  margin-top: 4px;\n  font-weight: 400;\n  font-size: 16px;\n  color: var(--grey-400);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"usp": `QUGEOGm8RCVGK0CCYQKv`,
	"textContainer": `d8UbBaTPdBHCLRWWIW8Z`,
	"subTitle": `QG6LffBNcAkvTLMDoLfK`
};
export default ___CSS_LOADER_EXPORT___;
